import { render } from "./FilterEntitasList.vue?vue&type=template&id=4a0f297f"
import script from "./FilterEntitasList.vue?vue&type=script&lang=js"
export * from "./FilterEntitasList.vue?vue&type=script&lang=js"
script.render = render

export default script